import React, { useState } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import "./Navbar.css";

export default function App() {
  const [userName, setUserName] = useState(
    localStorage.getItem("userName") || "zack"
  );
  return (
    <>
      <nav>
        <ul>
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>
            <NavLink to="/profile">Profile</NavLink>
          </li>
        </ul>
      </nav>
      <Routes>
        <Route path="/" element={<Home userName={userName} />} />
        <Route
          path="/profile"
          element={<Profile userName={userName} setUserName={setUserName} />}
        />
      </Routes>
    </>
  );
}
